import { render } from "./FrameComp.vue?vue&type=template&id=b7b71d64&scoped=true"
import script from "./FrameComp.vue?vue&type=script&lang=js"
export * from "./FrameComp.vue?vue&type=script&lang=js"

import "./FrameComp.vue?vue&type=style&index=0&id=b7b71d64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7b71d64"]])

export default __exports__